export interface PolicyRuleIcon {
  id: string;
  /** One code point, no U+200D or U+FE0F. The guest app maps it to its own image. */
  symbol: string;
}

export const POLICY_RULE_ICONS: readonly PolicyRuleIcon[] = [
  { id: "checkin", symbol: "\u{1F552}" },
  { id: "cancellation", symbol: "\u{1F9FE}" },
  { id: "family", symbol: "\u{1F46A}" },
  { id: "pets", symbol: "\u{1F436}" },
  { id: "parking", symbol: "\u{1F697}" },
  { id: "breakfast", symbol: "\u{1F373}" },
  { id: "smoking", symbol: "\u{1F6AD}" },
  { id: "wifi", symbol: "\u{1F4F6}" },
  { id: "quiet", symbol: "\u{1F507}" },
  { id: "general", symbol: "\u{1F4CB}" },
];

export const POLICY_RULE_ICON_IDS = POLICY_RULE_ICONS.map((icon) => icon.id);

export const DEFAULT_POLICY_RULE_ICON_ID = "general";

export function getPolicyRuleIconSymbol(
  iconId: string | undefined,
): string | undefined {
  return POLICY_RULE_ICONS.find((icon) => icon.id === iconId)?.symbol;
}
